import type { SnapshotFrom } from 'xstate';
import { feature, useFeature } from '@/app/context';
import { clientMachine } from './client.machine';

export const useClientRef = () => feature('client');
export const useClient = <R>(selector: (snapshot: SnapshotFrom<typeof clientMachine>) => R) =>
  useFeature('client', selector);
export const useClientActions = () => {
  const ref = useClientRef();
  return {
    loadClients: () => ref.send({ type: 'client.load-clients' }),
    register: (clientName: string, fiduciaryName: string, beneficiaries: string[]) =>
      ref.send({ type: 'client.register', clientName, fiduciaryName, beneficiaries }),
  };
};
